import { decode, encode } from 'he';

export const encodeHtmlEntities = (text) =>
  encode(text, {
    useNamedReferences: true,
  });

export const decodeHtmlEntities = (text) => decode(text);

export const stripHtmlTags = (html) => {
  const div = document.createElement('div');
  div.innerHTML = `${html}`;
  return div.textContent || div.innerText || `${html}`.replace(/<\/?[^>]+(>|$)/g, '') || '';
};

/**
 * Check if passed content is HTML
 * @param {string} content - text
 * @returns {boolean} - true if the content is HTML
 */
export const isHtmlContent = (content) => /<\/?[a-z][\s\S]*>/i.test(content);
